export interface VectorMapCountry {
  value: number;
  name: string;
  code: string;
}

export interface VectorMapView {
  id: string;
  text: string;
}
export interface VectorMapViewsDataSource {
  data: Record<string, Partial<VectorMapCountry>[]>;
  views: VectorMapView[];
}

export type VectorMapDataSource = Partial<VectorMapCountry>[] | VectorMapViewsDataSource;

export const COUNTRIES: VectorMapCountry[] = [
  { name: 'Afghanistan', value: 0, code: 'AFG' },
  { name: 'Albania', value: 0, code: 'ALB' },
  { name: 'Algeria', value: 0, code: 'DZA' },
  { name: 'American Samoa', value: 0, code: 'ASM' },
  { name: 'Andorra', value: 0, code: 'AND' },
  { name: 'Angola', value: 0, code: 'AGO' },
  { name: 'Anguilla', value: 0, code: 'AIA' },
  { name: 'Antigua and Barbuda', value: 0, code: 'ATG' },
  { name: 'Argentina', value: 0, code: 'ARG' },
  { name: 'Armenia', value: 0, code: 'ARM' },
  { name: 'Aruba', value: 0, code: 'ABW' },
  { name: 'Australia', value: 0, code: 'AUS' },
  { name: 'Austria', value: 0, code: 'AUT' },
  { name: 'Azerbaijan', value: 0, code: 'AZE' },
  { name: 'Bahamas, The', value: 0, code: 'BHM' },
  { name: 'Bahrain', value: 0, code: 'BHR' },
  { name: 'Bangladesh', value: 0, code: 'BGD' },
  { name: 'Barbados', value: 0, code: 'BRB' },
  { name: 'Belarus', value: 0, code: 'BLR' },
  { name: 'Belgium', value: 0, code: 'BEL' },
  { name: 'Belize', value: 0, code: 'BLZ' },
  { name: 'Benin', value: 0, code: 'BEN' },
  { name: 'Bermuda', value: 0, code: 'BMU' },
  { name: 'Bhutan', value: 0, code: 'BTN' },
  { name: 'Bolivia', value: 0, code: 'BOL' },
  { name: 'Bosnia and Herzegovina', value: 0, code: 'BIH' },
  { name: 'Botswana', value: 0, code: 'BWA' },
  { name: 'Brazil', value: 0, code: 'BRA' },
  { name: 'British Virgin Islands', value: 0, code: 'VGB' },
  { name: 'Brunei', value: 0, code: 'BRN' },
  { name: 'Bulgaria', value: 0, code: 'BGR' },
  { name: 'Burkina Faso', value: 0, code: 'BFA' },
  { name: 'Burma', value: 0, code: 'MMR' },
  { name: 'Burundi', value: 0, code: 'BDI' },
  { name: 'Cabo Verde', value: 0, code: 'CPV' },
  { name: 'Cambodia', value: 0, code: 'KHM' },
  { name: 'Cameroon', value: 0, code: 'CMR' },
  { name: 'Canada', value: 0, code: 'CAN' },
  { name: 'Cayman Islands', value: 0, code: 'CYM' },
  { name: 'Central African Republic', value: 0, code: 'CAF' },
  { name: 'Chad', value: 0, code: 'TCD' },
  { name: 'Chile', value: 0, code: 'CHL' },
  { name: 'China', value: 0, code: 'CHN' },
  { name: 'Colombia', value: 0, code: 'COL' },
  { name: 'Comoros', value: 0, code: 'COM' },
  { name: 'Congo, Democratic Republic of the', value: 0, code: 'COD' },
  { name: 'Congo, Republic of the', value: 0, code: 'COG' },
  { name: 'Cook Islands', value: 0, code: 'COK' },
  { name: 'Costa Rica', value: 0, code: 'CRI' },
  { name: "Cote d'Ivoire", value: 0, code: 'CIV' },
  { name: 'Croatia', value: 0, code: 'HRV' },
  { name: 'Cuba', value: 0, code: 'CUB' },
  { name: 'Curacao', value: 0, code: 'CUW' },
  { name: 'Cyprus', value: 0, code: 'CYP' },
  { name: 'Czech Republic', value: 0, code: 'CZE' },
  { name: 'Denmark', value: 0, code: 'DNK' },
  { name: 'Djibouti', value: 0, code: 'DJI' },
  { name: 'Dominica', value: 0, code: 'DMA' },
  { name: 'Dominican Republic', value: 0, code: 'DOM' },
  { name: 'Ecuador', value: 0, code: 'ECU' },
  { name: 'Egypt', value: 0, code: 'EGY' },
  { name: 'El Salvador', value: 0, code: 'SLV' },
  { name: 'Equatorial Guinea', value: 0, code: 'GNQ' },
  { name: 'Eritrea', value: 0, code: 'ERI' },
  { name: 'Estonia', value: 0, code: 'EST' },
  { name: 'Ethiopia', value: 0, code: 'ETH' },
  { name: 'Falkland Islands (Islas Malvinas)', value: 0, code: 'FLK' },
  { name: 'Faroe Islands', value: 0, code: 'FRO' },
  { name: 'Fiji', value: 0, code: 'FJI' },
  { name: 'Finland', value: 0, code: 'FIN' },
  { name: 'France', value: 0, code: 'FRA' },
  { name: 'French Polynesia', value: 0, code: 'PYF' },
  { name: 'Gabon', value: 0, code: 'GAB' },
  { name: 'Gambia, The', value: 0, code: 'GMB' },
  { name: 'Georgia', value: 0, code: 'GEO' },
  { name: 'Germany', value: 0, code: 'DEU' },
  { name: 'Ghana', value: 0, code: 'GHA' },
  { name: 'Gibraltar', value: 0, code: 'GIB' },
  { name: 'Greece', value: 0, code: 'GRC' },
  { name: 'Greenland', value: 0, code: 'GRL' },
  { name: 'Grenada', value: 0, code: 'GRD' },
  { name: 'Guam', value: 0, code: 'GUM' },
  { name: 'Guatemala', value: 0, code: 'GTM' },
  { name: 'Guernsey', value: 0, code: 'GGY' },
  { name: 'Guinea-Bissau', value: 0, code: 'GNB' },
  { name: 'Guinea', value: 0, code: 'GIN' },
  { name: 'Guyana', value: 0, code: 'GUY' },
  { name: 'Haiti', value: 0, code: 'HTI' },
  { name: 'Honduras', value: 0, code: 'HND' },
  { name: 'Hong Kong', value: 0, code: 'HKG' },
  { name: 'Hungary', value: 0, code: 'HUN' },
  { name: 'Iceland', value: 0, code: 'ISL' },
  { name: 'India', value: 0, code: 'IND' },
  { name: 'Indonesia', value: 0, code: 'IDN' },
  { name: 'Iran', value: 0, code: 'IRN' },
  { name: 'Iraq', value: 0, code: 'IRQ' },
  { name: 'Ireland', value: 0, code: 'IRL' },
  { name: 'Isle of Man', value: 0, code: 'IMN' },
  { name: 'Israel', value: 0, code: 'ISR' },
  { name: 'Italy', value: 0, code: 'ITA' },
  { name: 'Jamaica', value: 0, code: 'JAM' },
  { name: 'Japan', value: 0, code: 'JPN' },
  { name: 'Jersey', value: 0, code: 'JEY' },
  { name: 'Jordan', value: 0, code: 'JOR' },
  { name: 'Kazakhstan', value: 0, code: 'KAZ' },
  { name: 'Kenya', value: 0, code: 'KEN' },
  { name: 'Kiribati', value: 0, code: 'KIR' },
  { name: 'Korea, North', value: 0, code: 'PRK' },
  { name: 'Korea, South', value: 0, code: 'KOR' },
  { name: 'Kosovo', value: 0, code: 'KSV' },
  { name: 'Kuwait', value: 0, code: 'KWT' },
  { name: 'Kyrgyzstan', value: 0, code: 'KGZ' },
  { name: 'Laos', value: 0, code: 'LAO' },
  { name: 'Latvia', value: 0, code: 'LVA' },
  { name: 'Lebanon', value: 0, code: 'LBN' },
  { name: 'Lesotho', value: 0, code: 'LSO' },
  { name: 'Liberia', value: 0, code: 'LBR' },
  { name: 'Libya', value: 0, code: 'LBY' },
  { name: 'Liechtenstein', value: 0, code: 'LIE' },
  { name: 'Lithuania', value: 0, code: 'LTU' },
  { name: 'Luxembourg', value: 0, code: 'LUX' },
  { name: 'Macau', value: 0, code: 'MAC' },
  { name: 'Macedonia', value: 0, code: 'MKD' },
  { name: 'Madagascar', value: 0, code: 'MDG' },
  { name: 'Malawi', value: 0, code: 'MWI' },
  { name: 'Malaysia', value: 0, code: 'MYS' },
  { name: 'Maldives', value: 0, code: 'MDV' },
  { name: 'Mali', value: 0, code: 'MLI' },
  { name: 'Malta', value: 0, code: 'MLT' },
  { name: 'Marshall Islands', value: 0, code: 'MHL' },
  { name: 'Mauritania', value: 0, code: 'MRT' },
  { name: 'Mauritius', value: 0, code: 'MUS' },
  { name: 'Mexico', value: 0, code: 'MEX' },
  { name: 'Micronesia, Federated States of', value: 0, code: 'FSM' },
  { name: 'Moldova', value: 0, code: 'MDA' },
  { name: 'Monaco', value: 0, code: 'MCO' },
  { name: 'Mongolia', value: 0, code: 'MNG' },
  { name: 'Montenegro', value: 0, code: 'MNE' },
  { name: 'Morocco', value: 0, code: 'MAR' },
  { name: 'Mozambique', value: 0, code: 'MOZ' },
  { name: 'Namibia', value: 0, code: 'NAM' },
  { name: 'Nepal', value: 0, code: 'NPL' },
  { name: 'Netherlands', value: 0, code: 'NLD' },
  { name: 'New Caledonia', value: 0, code: 'NCL' },
  { name: 'New Zealand', value: 0, code: 'NZL' },
  { name: 'Nicaragua', value: 0, code: 'NIC' },
  { name: 'Nigeria', value: 0, code: 'NGA' },
  { name: 'Niger', value: 0, code: 'NER' },
  { name: 'Niue', value: 0, code: 'NIU' },
  { name: 'Northern Mariana Islands', value: 0, code: 'MNP' },
  { name: 'Norway', value: 0, code: 'NOR' },
  { name: 'Oman', value: 0, code: 'OMN' },
  { name: 'Pakistan', value: 0, code: 'PAK' },
  { name: 'Palau', value: 0, code: 'PLW' },
  { name: 'Panama', value: 0, code: 'PAN' },
  { name: 'Papua New Guinea', value: 0, code: 'PNG' },
  { name: 'Paraguay', value: 0, code: 'PRY' },
  { name: 'Peru', value: 0, code: 'PER' },
  { name: 'Philippines', value: 0, code: 'PHL' },
  { name: 'Poland', value: 0, code: 'POL' },
  { name: 'Portugal', value: 0, code: 'PRT' },
  { name: 'Puerto Rico', value: 0, code: 'PRI' },
  { name: 'Qatar', value: 0, code: 'QAT' },
  { name: 'Romania', value: 0, code: 'ROU' },
  { name: 'Russia', value: 0, code: 'RUS' },
  { name: 'Rwanda', value: 0, code: 'RWA' },
  { name: 'Saint Kitts and Nevis', value: 0, code: 'KNA' },
  { name: 'Saint Lucia', value: 0, code: 'LCA' },
  { name: 'Saint Martin', value: 0, code: 'MAF' },
  { name: 'Saint Pierre and Miquelon', value: 0, code: 'SPM' },
  { name: 'Saint Vincent and the Grenadines', value: 0, code: 'VCT' },
  { name: 'Samoa', value: 0, code: 'WSM' },
  { name: 'San Marino', value: 0, code: 'SMR' },
  { name: 'Sao Tome and Principe', value: 0, code: 'STP' },
  { name: 'Saudi Arabia', value: 0, code: 'SAU' },
  { name: 'Senegal', value: 0, code: 'SEN' },
  { name: 'Serbia', value: 0, code: 'SRB' },
  { name: 'Seychelles', value: 0, code: 'SYC' },
  { name: 'Sierra Leone', value: 0, code: 'SLE' },
  { name: 'Singapore', value: 0, code: 'SGP' },
  { name: 'Sint Maarten', value: 0, code: 'SXM' },
  { name: 'Slovakia', value: 0, code: 'SVK' },
  { name: 'Slovenia', value: 0, code: 'SVN' },
  { name: 'Solomon Islands', value: 0, code: 'SLB' },
  { name: 'Somalia', value: 0, code: 'SOM' },
  { name: 'South Africa', value: 0, code: 'ZAF' },
  { name: 'South Sudan', value: 0, code: 'SSD' },
  { name: 'Spain', value: 0, code: 'ESP' },
  { name: 'Sri Lanka', value: 0, code: 'LKA' },
  { name: 'Sudan', value: 0, code: 'SDN' },
  { name: 'Suriname', value: 0, code: 'SUR' },
  { name: 'Swaziland', value: 0, code: 'SWZ' },
  { name: 'Sweden', value: 0, code: 'SWE' },
  { name: 'Switzerland', value: 0, code: 'CHE' },
  { name: 'Syria', value: 0, code: 'SYR' },
  { name: 'Taiwan', value: 0, code: 'TWN' },
  { name: 'Tajikistan', value: 0, code: 'TJK' },
  { name: 'Tanzania', value: 0, code: 'TZA' },
  { name: 'Thailand', value: 0, code: 'THA' },
  { name: 'Timor-Leste', value: 0, code: 'TLS' },
  { name: 'Togo', value: 0, code: 'TGO' },
  { name: 'Tonga', value: 0, code: 'TON' },
  { name: 'Trinidad and Tobago', value: 0, code: 'TTO' },
  { name: 'Tunisia', value: 0, code: 'TUN' },
  { name: 'Turkey', value: 0, code: 'TUR' },
  { name: 'Turkmenistan', value: 0, code: 'TKM' },
  { name: 'Tuvalu', value: 0, code: 'TUV' },
  { name: 'Uganda', value: 0, code: 'UGA' },
  { name: 'Ukraine', value: 0, code: 'UKR' },
  { name: 'United Arab Emirates', value: 0, code: 'ARE' },
  { name: 'United Kingdom', value: 0, code: 'GBR' },
  { name: 'United States', value: 0, code: 'USA' },
  { name: 'Uruguay', value: 0, code: 'URY' },
  { name: 'Uzbekistan', value: 0, code: 'UZB' },
  { name: 'Vanuatu', value: 0, code: 'VUT' },
  { name: 'Venezuela', value: 0, code: 'VEN' },
  { name: 'Vietnam', value: 0, code: 'VNM' },
  { name: 'Virgin Islands', value: 0, code: 'VGB' },
  { name: 'West Bank', value: 0, code: 'WBG' },
  { name: 'Yemen', value: 0, code: 'YEM' },
  { name: 'Zambia', value: 0, code: 'ZMB' },
  { name: 'Zimbabwe', value: 0, code: 'ZWE' }
];

export interface VectorMapLegend {
  text: string;
  color: string;
}

export const DEFAULT_DATA = {
  type: 'choropleth',
  hoverinfo: 'none',
  autocolorscale: false,
  reversescale: true,
  marker: {
    line: {}
  },
  tick0: 0,
  zmin: 0,
  zmax: 1,
  showscale: false
};

export const DEFAULT_LAYOUT = {
  autosize: true,
  geo: {
    showframe: false,
    showcoastlines: false,
    projection: {
      type: 'miller'
    },
    center: {
      lat: 25,
      lon: 0
    }
  },
  margin: {
    l: 0,
    r: 0,
    b: 0,
    t: 0,
    pad: 0
  }
};

export const DEFAULT_CONFIG = {
  displayModeBar: false,
  responsive: true
};

export const DEFAULT_STYLE = {
  position: 'relative',
  width: '100%',
  height: '100%'
};
